<template>
<v-container class="mt-5">
  <v-row class="pt-10">
    <v-col cols="12" class="d-flex flex-row my-0 py-0">
      <v-text-field
          :style="{width: $vuetify.breakpoint.smAndDown ? '60vw' : '40vw'}"
          placeholder="Search by question"
          label="Search by question"
          solo
          flat
          v-model.lazy="searchString"
          @keydown.enter="searchQuestion(searchString)"
          @input="debounceSearch(searchString)"
      />
      <v-btn
          v-if="$vuetify.breakpoint.smAndDown"
          @click="openFilterDialog = !openFilterDialog"
          elevation="0"
          height="3.3em"
          color="primary"
          class="ml-4"
      >
        Set Filters
      </v-btn>
    </v-col>
    <GradeSubjectTopicFilters
        :dialog="openFilterDialog"
        @applyFilters="onApplyFilters($event)"
        @clearFilters="fetchQuestions(`/qb/questions/?limit=${limit}`)"
    />
  </v-row>
  <h2 class="mb-5">Questions</h2>
  <div  v-if="error">
    <v-alert
        text
        prominent
        type="error"
        icon="mdi-cloud-alert"
        dismissible
        :style="{width: $vuetify.breakpoint.xs ? '100vw' : '50vw'}"
    >
      <div>
        <p>{{error}}</p>
        <p>Please refresh page</p>
      </div>
    </v-alert>
  </div>
  <template v-if="!loading">
    <template v-if="questions.length">
      <v-row class="mb-10" >
        <v-col v-for="(question, index) in questions" :key="index" md="12" lg="12" sm="12">
          <v-card
            rounded
            elevation="1"
            class="px-5 py-5"
            :to="`/questions/${question.uuid}`"
            v-if="question.question"
        >
          <v-card-title class="d-block question" v-html="question.question" />
          <v-chip
              class="ma-2"
              color="primary"

              small
              v-if="question.paper.subject.name"
          >
            Subject: {{ question.paper.subject.name }}
          </v-chip>
          <v-chip
              class="ma-2"
              color="primary"
              small
              v-if="question.topic.title"
          >
            Topic: {{ question.topic.title }}
          </v-chip>
          <v-chip
              class="ma-2"
              color="red"
              text-color="white"
              small
              v-if="question.paper.grade_level.grade"
          >
            Grade: {{ question.paper.grade_level.grade }}
          </v-chip>
          <v-chip
              class="ma-2"
              color="green"
              text-color="white"
              small
              v-if="question.paper.exam_body.name && question.paper.year"
          >
            {{ question.paper.exam_body.name  }}: {{ new Date(question.paper.year).getFullYear() }}
          </v-chip>
          <v-chip
              class="ma-2"
              color="green"
              text-color="white"
              small
              v-if="question.section.section"
          >
            Section: {{ question.section.section }}
          </v-chip>
          <v-card-actions>
            <v-btn
                elevation="0"
                color="teal accent-4"
                :to="`/questions/${question.uuid}`"
            >
              View
            </v-btn>
          </v-card-actions>
        </v-card>
        </v-col>
        <v-col cols="12">
          <infinite-loading spinner="waveDots" @infinite="fetchMoreQuestions">
            <div slot="no-results">
              <v-chip small text-color="primary">You have caught up</v-chip>
            </div>
            <div slot="no-more">
              <v-chip small text-color="primary">You have caught up</v-chip>
            </div>
          </infinite-loading>
        </v-col>
      </v-row>
    </template>
    <NoData v-else title="There are no questions to show :("/>
  </template>
  <template v-else>
    <v-row >
      <v-col v-for="(_, index) in loaders" :key="index" md="12" lg="12" cols="12">
        <v-card class="mb-10">
          <v-skeleton-loader type="article"></v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
  </template>
</v-container>
</template>

<script>
import Logo from "@/assets/guiomentorLogo.png";
import NoData from "@/components/NoData";
import GradeSubjectTopicFilters from "@/components/GradeSubjectTopicFilters";
import InfiniteScroll from "@/mixins/InfiniteScroll";

export default {
  name: "QuestionBankIndex",
  components: {GradeSubjectTopicFilters, NoData},
  mixins: [InfiniteScroll],
  metaInfo() {
    return {
      title: 'Guiomentor - All Questions',
      url: window.location.href,
      meta: [
        {name: 'title', content: 'Guiomentor - Question Bank List'},
        {
          name: 'description',
          content: this.description
        },
        //Facebook
        {name: 'og:type', content: 'Website'},
        {name: 'og:title', content: "Guiomentor - Question Bank List"},
        {name: 'og:description', content: this.description},
        {name: 'og:image', content: this.logo},

        // Twitter
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:url', content: window.location.href},
        {name: 'twitter:title', content: "Guiomentor - Question Bank List"},
        {name: 'twitter:description', content: this.description},
        {name: 'twitter:image', content: this.logo},
      ]
    }
  },
  data: () => ({
    loaders: [1,2,4,5],
    loading: false,
    openFilterDialog: false,
    count: 0,
    limit: 6,
    offset: 6,
    next: null,
    error: null,
    results: {
      "count": 1,
      "next": null,
      "previous": null,
      "results": []
    },
    page: 1,
    logo: Logo,
    questions: [],
    searchString: "",
    fetchUrl: "",
    description: ""
  }),
  async mounted() {
    await this.fetchQuestions(`/qb/questions/?limit=${this.limit}`);
  },
  methods: {
    async fetchQuestions(url) {
      this.fetchUrl = url
      try{
        this.error = null;
        this.loading = true
        const {data} = await this.axios.get(url);
        this.questions = data.results;
        this.next = data.next;
        this.count = data.count;
      }catch (e) {
      this.error = e.message || 'Something went wrong while fetching the questions'
      } finally {
         this.loading = false;
      }
    },
    debounceSearch(searchString){
      clearTimeout(this._timerId)
      this._timerId = setTimeout(()=> {this.searchQuestion(searchString)},1100)
    },
    searchQuestion(searchString){
      this.fetchQuestions(`/qb/questions/?search=${searchString}&limit=${this.limit}`);
    },
    onApplyFilters(filters) {
      this.openFilterDialog = false
      const gradeLevelParam = filters.grade.id ? `grade_level=${filters.grade.id}` : ""
      const subjectParam = filters.subject.id ? `&subject=${filters.subject.id}` : ""
      const topicParam = filters.topic.id ? `&topic=${filters.topic.id}` : ""
      const yearParam = filters.year ? `&year=${filters.year}` : ""
      this.fetchQuestions(`qb/papers/?${gradeLevelParam + subjectParam + topicParam + yearParam}&limit=${this.limit}`)
    },
    fetchMoreQuestions($state) {
      this.infiniteHandler($state, "", false, "questions")
    },
  }
}
</script>

<style scoped lang="scss">
.v-btn {
  text-transform: none !important;
  font-family: Montserrat, sans-serif;
}
.question {
  ::v-deep br {
    display: none;
  }
  ::v-deep p {
    margin: 0;
    font-family: Montserrat, sans-serif;
  }
}
</style>
